export default "__VITE_ASSET__BnF7m2kz__"